/**
 * @file: 普通层板tpl申明
 * @author: xiaolong.huang@dmall.com
 */

let tpl: string = `
    <div class="shelvesbuild-e-p-layer is-partition" data-stagecore>
        <!-- 商品放置区域 -->
        <div class="shelvesbuild-e-p-layer-slot J_ElementPartitionLayerSlot slot drop-area"></div>

        <!-- 层板底部厚度区域 -->
        <div class="partition-layer-bone J_PartitionLayerBone">
            <!-- 流动线 -->
            <span class="flow-border-left"><i></i></span>
            <span class="flow-border-right"><i></i></span>
            <span class="flow-border-top"><i></i></span>
            <span class="flow-border-bottom"><i></i></span>

            <!-- 实线边框 -->
            <span class="solid-border-left"></span>
            <span class="solid-border-right"></span>
            <span class="solid-border-top"></span>
            <span class="solid-border-bottom"></span>

            <div class="layer-tags">
                <span class="tags-text J_LayerTag hide"></span>
                <span style="flex-grow: 1;min-width: 1px;"></span>
                <div class="module-tag-text module-tag-text--hide">
                    <span class="tag-value"></span>
                    <i class="module-tag"></i>
                    <i class="not-check" title="默认此层板上的全部商品直接通过检核"></i>
                </div>
                <span class="slop-text"></span>
            </div>
            <div class="group-right">
                <span class="group-right__inner"></span>
            </div>
            <div class="group-left">
                <span class="group-right__inner"></span>
            </div>
        </div>

        <!-- 围栏 -->
        <div class="gratingBox"></div>
        <i class="is-in-stage"></i>
        <span class="selected-mask"></span>
    </div>
`;

export default tpl;
